import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetPerformanceAudienceDashboardQuery } from '@/services/endpoints/performanceAudience';
import { useCallback } from 'react';
import { PerformanceAudienceDateRange, PerformanceAudienceFiltersState } from '../types';

export const usePerformanceDashboardData = (filters: PerformanceAudienceFiltersState, enabled: boolean) => {
  const { id: workspaceId } = useWorkspace();

  const shouldFetch = !!workspaceId && enabled;

  const { data, isLoading, isFetching, isError, refetch } = useGetPerformanceAudienceDashboardQuery(
    {
      workspaceId,
      audienceId: filters.audienceId,
      googleScopeId: filters.googleScopeId,
      metaScopeId: filters.metaScopeId,
      dateRange: filters.dateRange as PerformanceAudienceDateRange,
    },
    { skip: !shouldFetch }
  );

  const isInitialLoading = shouldFetch && isLoading && !data;
  const isRefetching = shouldFetch && isFetching && !!data;

  const refetchDashboard = useCallback(() => {
    void refetch();
  }, [refetch]);

  return {
    summary: data?.summary,
    kpis: data?.kpis ?? [],
    trend: data?.trend,
    comparison: data?.comparison ?? [],
    storeVisits: data?.storeVisits,
    isLoading: isInitialLoading,
    isRefetching,
    isError: shouldFetch && isError,
    refetch: refetchDashboard,
    hasData: !!data,
  };
};
